module.exports = __webpack_public_path__ + "static/media/maf-05.1ff5c173.png";